var frameIndex = 0;
var frames = $('.lookbook-wrapper .look');
var S = {}
$(document).ready(function() {


  S.size = {}
  S.size.all = function() {
    S.size.windowW = $(window).outerWidth();
    S.size.windowH = $(window).outerHeight();
    S.size.header = $(".header-interior").outerHeight();

    S.isDesktop = false;
    S.isTablet = false;
    S.isMobile = false;
    S.isLandscape = window.matchMedia("(orientation: landscape)").matches;


    if (S.size.windowW > 1024 || S.isLandscape) {
      S.isDesktop = true;
    } else if (S.size.windowW > 767) {
      S.isTablet = true;
    } else {
      S.isMobile = true;
    }
  }




  S.scroll = {}
  S.scroll.action = function() {
    var scroll = $(window).scrollTop(), $h = $(".header:not(.with-promo-bar)"), $scrolls = $(".scroll-down, .scroll-up"),
    limit = 80;

    if (scroll > limit) {
      $h.addClass("header--scrolled");
      document.getElementsByTagName('html')[0].classList.add("scroll");
      $scrolls.addClass("header--scrolled");
    } else if (scroll <= limit) {
      $h.removeClass("header--scrolled");
      document.getElementsByTagName('html')[0].classList.remove("scroll");
      $scrolls.removeClass("header--scrolled");
    }

    if (scroll > 10) {
      //console.log("scroll: " + scroll);
      $h.addClass("header--actually-scrolled");
      //document.html.classList.add("scrolled");
    } else if (scroll <= 10) {
      //console.log("scroll: " + scroll);
      $h.removeClass("header--actually-scrolled");
      //document.html.classList.remove("scrolled");
    }
  }

  S.scroll.lock = function() {
    bodyScrollLock.disableBodyScroll($("#page-container"), {
       allowTouchMove: el => {
         while (el && el !== document.body) {
           if (el.getAttribute("body-scroll-lock-ignore") !== null) {
             return true
           }
           el = el.parentNode
         }
       }
     })
  }

  S.scroll.unlock = function() {
    bodyScrollLock.clearAllBodyScrollLocks();
  }


  S.list = {}
  S.list.pop = function() {
    var $pop = $(".newsletter-popup");
    var $form = $("#pop_newsletter");

    if ($pop.length) {
      var cookiename = 'fog_emailpop_cookie';
      var cookie1 = Cookies.get(cookiename);
      var skipCookie = false;

      if (!cookie1 || skipCookie === true) {
        // no cookie, so set cookie
        Cookies.set(cookiename, 'visited', {
          expires: parseInt($form.attr("data-cookie-expire")),
          path: '/'
        });

        setTimeout(function() {
          $pop.addClass("active").find(".x-sm-close").click(function(e) {
            $(".newsletter-popup").removeClass("active");
          });
          $pop.find(".overlay").click(function(e) {
            $(".newsletter-popup").removeClass("active");
          });
          $pop.find(".router_message button").click(function(e) {
            $(".newsletter-popup").removeClass("active");
          });
        }, 1200);
      }

      KlaviyoSubscribe.attachToForms('#pop_newsletter', {
        hide_form_on_success: true,
        success_message: $("#pop_newsletter").attr("data-success-msg"),
        success: function ($form) {
         // `$form` is a jQuery wrapper around the form that was submitted. This makes it easy to get the email address or form fields.
         $form.addClass("submitted");
         setTimeout(function() {
           $(".newsletter-popup").find(".x-sm-close").trigger("click");
         }, 3000)
        }
      });
    }
  }




  S.lookbook = {}
  S.lookbook.init = function() {
    $(".layout-page-lookbook .lookbook").each(function() {
      $(this).find(".link-overlay").click(function(e) {
        e.preventDefault();
        var id = $(this).attr("data-id");
        S.lookbook.detail(id);
      })
    })
    
    $(".layout-page-2024-eternal-v2-lookbook .lookbook").each(function() {
      $(this).find(".link-overlay").click(function(e) {
        e.preventDefault();
        var id = $(this).attr("data-id");
        S.lookbook.detail(id);
      })
    })

    var hash = window.location.hash;
    // console.log("hash: " + hash);

    if (hash && hash != "" && ($(".layout-page-lookbook .look"+hash).length) ){
      console.log("found look? " + $(".layout-page-lookbook .look"+hash).length);
      $(".layout-page-lookbook .look"+hash+" .link-overlay").trigger("click");
    }

    if (hash && hash != "" && ($(".layout-page-2024-eternal-v2-lookbook .look"+hash).length) ){
      console.log("found look? " + $(".layout-page-2024-eternal-v2-lookbook .look"+hash).length);
      $(".layout-page-2024-eternal-v2-lookbook .look"+hash+" .link-overlay").trigger("click");
    }
  }

  S.lookbook.detail = function(id) {
    var looks = '';
    var tot = $(".lookbook .look").length;
    $(".lookbook .look").each(function() {
      var no = $(this).index() + 1;
      var src = $(this).attr("data-src-full");
      var alt = $(this).find("img").attr("alt");
      var detail_id = $(this).attr("id") + "-detail";
      var pagi = '<span class="lookbook-pagi type-e">'+no+'/'+tot+'</span>';
      var caption = '', landscape = $(this).hasClass("landscape-true");
      if ($(this).find(".block-content").length) {
        caption = '<div class="block-content type-f">'+$(this).find(".block-content").html()+'</div>';
      }
      var btn = '<button class="clear-btn link-overlay zoom-btn" aria-label="Zoom"><span class="displace">Zoom</span></button>';
      if (id == $(this).attr("id")) {
        var look = `<div class="block-image"><img
                  class="picture__img"
                  src="`+src+`"
                  data-src="`+src+`"
                  data-zoom-src="`+src+`"
                  alt="`+alt+` "
                />`+btn+`</div>`;
      } else {
        var look = `<div class="block-image"><img
                  class="picture__img lazyload"
                  data-src="`+src+`"
                  data-zoom-src="`+src+`"
                  alt="`+alt+` "
                />`+btn+`</div>`;
      }
      look = '<div class="block-interior">'+look+caption+'</div>';
      looks = looks + '<div class="look-detail landscape-'+landscape+'" id="'+detail_id+'">'+look+pagi+'</div>';
    })

    var scroll_up = `<button class="clear-btn scroll-up-looks" aria-label="Back to Top">
    	<svg xmlns="http://www.w3.org/2000/svg" width="14.691" height="23.01" viewBox="0 0 14.691 23.01">
    	  <g id="Component_22_9" data-name="Component 22 – 9" transform="translate(0.36)">
    	    <g id="Group_26167" data-name="Group 26167" transform="translate(13.972) rotate(90)">
    	      <line id="Line_1234" data-name="Line 1234" x2="22.465" transform="translate(0 6.986)" fill="none" stroke="#000" stroke-width="1"/>
    	      <g id="Group_25960" data-name="Group 25960" transform="translate(15.421)">
    	        <line id="Line_1235" data-name="Line 1235" x2="7.242" y2="7.01" fill="none" stroke="#000" stroke-width="1"/>
    	        <line id="Line_1236" data-name="Line 1236" y1="6.962" x2="7.242" transform="translate(0 7.01)" fill="none" stroke="#000" stroke-width="1"/>
    	      </g>
    	    </g>
    	  </g>
    	</svg>
    </button>`;
    var html = '<div class="lookbook-details zoom-parent" id="lookbook-details" body-scroll-lock-ignore>'+looks+'<a href="#" class="x-close" aria-label="Close"><span class="displace">Close</span></a>'+scroll_up+'</div>';

    $(".lookbook").after(html);
    S.scroll.lock();
    $(".lookbook-details .x-close").click(function(e) {
      e.preventDefault();
      window.history.back();
      S.scroll.unlock();
      $(".lookbook-details").remove();
      for (i = 0; i < S.scroll.sectionWatchers.length; ++i) {
          S.scroll.sectionWatchers[i].destroy();
      }
      S.scroll.sectionWatchers = [];
    })

    // set correct scroll position for active id
    setTimeout(function() {
      console.log("id: " + id);
      var active_detail_id = '#' + id + "-detail";
      var top = $(active_detail_id).position().top;
      $(".lookbook-details").scrollTop(top).addClass("inited");
      if ($(active_detail_id).index() >= 9) {
        $up.addClass("show");
      }
    }, 200)

    var $up = $(".scroll-up-looks");
    $up.click(function(e) {
      e.preventDefault();
      $(".lookbook-details").animate({
        scrollTop: 0
      }, 150)
    })


    // setup scroll-based active state
    var containerElement = document.getElementById("lookbook-details");
    var containerMonitor = scrollMonitor.createContainer(containerElement);
    S.scroll.sectionWatchers = [];
      var f = 0;

    $(".look-detail").each(function() {
      var $t = $(this);
      S.scroll.sectionWatchers[f] = containerMonitor.create($t, S.size.windowH*-0.5);

      if (S.scroll.sectionWatchers[f].isInViewport) {
        $(this.watchItem).siblings().removeClass("active");
        $(this.watchItem).addClass("active");
        var id = $(this.watchItem).attr("id");
          console.log("id2: " + id);
        if (id) {
          id = id.replace("-detail", "");
          history.pushState(null, id, '#'+id);
        }


      }
      S.scroll.sectionWatchers[f].enterViewport(function() {
        var id = $(this.watchItem).attr("id");

        if (id && this.isFullyInViewport == true) {
          $(this.watchItem).siblings().removeClass("active");
          $(this.watchItem).addClass("active");
          var id = $(this.watchItem).attr("id");
          console.log(this.isFullyInViewport);
          console.log("id3: " + id + " / this.isFullyInViewport: " + this.isFullyInViewport);
          id = id.replace("-detail", "");
          history.pushState(null, id, '#'+id);
          if ($(this.watchItem).index() == 9) {
            $up.addClass("show");
          } else if ($(this.watchItem).index() == 8) {
            $up.removeClass("show");
          }
        }


      });
      f++;
    })

    // zoom functionality
    S.zoom.init($(".lookbook-details"));
    /*
    $(".lookbook-details .zoom-btn").click(function(e) {
      e.preventDefault();
      S.lookbook.zoom($(this));
    }) */

    // load the rest
    $(".look-detail img.lazyload").each(function() {
      $(this).attr("src", $(this).attr("data-src"));
    })
  }

  /*

  S.lookbook.zoom = function($t) {
    var img = $t.siblings("img").attr("src");
    $t.parents(".look-detail").first().append('<div class="zoom-image lookbook-zoom"><img src="'+img+'" /><span class="x-close"><span class="displace">Close</span></span></div>');
    if (S.isMobile) {
      $(".lookbook-zoom").animate({ scrollLeft: S.size.windowW }, 0);
    }
    $(".lookbook-zoom").addClass("inited").click(function(e) {
      e.preventDefault();
      $(".lookbook-zoom").remove();
    });
  } */




  S.film = {}
  S.film.init = function() {
    $(".layout-page-film").each(function() {
      $(this).find(".link-overlay").click(function(e) {
        e.preventDefault();
        e.preventDefault();
        $(".film-container.full").removeClass("inactive");
        videojs('playerfilm').play();
        $(".film-container.preview").remove();
      })
    })
  }


  S.overview = {}


  /*

  S.overview.init = function() {
    $(".layout-page-overview").each(function() {
      $(this).find(".zoom-btn").click(function(e) {
        e.preventDefault();
        S.overview.zoom($(this));
      })
    })

  }

  S.overview.zoom = function($t) {
    var img = $t.attr("data-zoom-src");
    $t.parents(".module").first().append('<div class="zoom-image overview-zoom"><img src="'+img+'" /><span class="x-close"><span class="displace">Close</span></span></div>');
    if (S.isMobile) {
      $(".overview-zoom").animate({ scrollLeft: S.size.windowW }, 0);
    }
    $(".overview-zoom").addClass("inited").click(function(e) {
      e.preventDefault();
      $(".overview-zoom").remove();
    });
  } */


  S.zoom =  {}

  S.zoom.init = function($s) {
    $s.find(".zoom-btn").on('click', function(e) {
      e.preventDefault();
      S.zoom.show($(this));
    })
  }


  let lastPdpZoomButton = null;

  document.querySelectorAll('.pdp-zoom-btn').forEach( el => {
    el.addEventListener('click', e => {
      lastPdpZoomButton = el;
    })
  });

  S.zoom.show = function($t) {
    var img = $t.siblings("img").attr("data-zoom-src");
    const alt = $t.siblings('img').attr('data-zoom-alt');
    const modalTitle = $t.siblings('img').attr('data-zoom-modal-title') + ' images';
    var imgArrStr = $t.siblings("img").attr("data-zoom-array-src");
    var imgArr = imgArrStr.split(', ');
    let imgHTML = '';
    imgArr.forEach((img, i) => {
      imgHTML += `<img src="${img}" alt="${alt} view ${i + 1}" />`;
    })
    if (!img) {
      img = $t.attr("data-zoom-src");
    }
    var scrollLeft = 0, scrollTop = 0;

    if ($t.hasClass("pdp-zoom-btn")) {
      $(".product-info-wrapper").addClass("zoomed");
      $(".purchase-section-interior,.preorder").addClass("z-up");
      $(".shoppingBagDrawer-wrapper").addClass("z-up");
      //scrollTop = S.size.windowH;
    }
    if (S.isMobile) {
      scrollLeft = S.size.windowW;
    }

    /*if (S.isMobile) {
      $t.parents(".zoom-parent").first().append('<div class="zoom-image" body-scroll-lock-ignore><img src="'+img+'" /><span class="x-close"><span class="displace">Close</span></span></div>');
    } else {*/
      $t.parents(".zoom-parent").first().append(`</div><div role="dialog" aria-modal="true" aria-label="${modalTitle}" class="zoom-image" body-scroll-lock-ignore><button aria-label="close" class="x-close"><span class="displace">Close</button></span><div class="zoom-inner" tabindex="0">${imgHTML}</div>`);
    //}
    $(".zoom-image").addClass("inited").click(function(e) {
      e.preventDefault();
      $(".zoom-image").remove();
      bodyScrollLock.clearAllBodyScrollLocks();
      if ($(".product-info-wrapper.zoomed").length) {
        $(".product-info-wrapper").removeClass("zoomed");
        $(".purchase-section-interior,.preorder").removeClass("z-up");
        $(".shoppingBagDrawer-wrapper").removeClass("z-up");
      }

      setTimeout(()=>{
        lastPdpZoomButton.focus();
      }, 500)
    });

    $(document).on('keyup.zoom_escape', function(e) {
     if (e.key === "Escape") {
        $(".zoom-image.inited").trigger("click");
        $(document).unbind('keyup.zoom_escape');
     }
    });

    $(".zoom-image img").imagesLoaded(function() {
      bodyScrollLock.disableBodyScroll($("#page-container"), {
         allowTouchMove: el => {
           while (el && el !== document.body) {
             if (el.getAttribute("body-scroll-lock-ignore") !== null) {
               return true
             }
             el = el.parentNode
           }
         }
       })

       const imageWrapper = document.querySelector('.zoom-image');
       const firstFocusableElement = imageWrapper.querySelector('.x-close');
       const images = [...imageWrapper.querySelectorAll('img')].reverse();
       //const lastFocusableElement = images.find(el => {
         //return getComputedStyle(el).display !== 'none';
       //});
       //const lastFocusableElement = imageWrapper.querySelector('.x-close');
       const lastFocusableElement = imageWrapper.querySelector('.zoom-inner');


       imageWrapper.addEventListener('keydown', (e) => {
         if (e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
           e.preventDefault();
           lastFocusableElement.focus();
         } else if (e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
           e.preventDefault();
           firstFocusableElement.focus();
         }
       });

      $(".zoom-image").animate({ scrollLeft: scrollLeft, scrollTop: scrollTop }, 0).addClass("image-loaded");

      firstFocusableElement.focus();
    })

  }



  S.pdp = {}
  S.pdp.getVariantInput = function($t) {
    var attr = $t.attr("data-attr");
    var value = $t.attr("data-value");
    var $variants = $("#product-variants");
    var $variant = $variants.find("input["+attr+"='"+value+"']");
    return $variant;
  }

  S.pdp.zoom = function($t) {

  }

  S.pdp.init = function() {
    $(".product-wrapper .zoom-btn").on('click', function(e) {
      e.preventDefault();
      S.pdp.zoom($(this));
    })

    $(".purchase-section > .blocker").on('click', function(e) {
      e.preventDefault();
      $(".purchase-section").find("button.product-option-selector.active").trigger("click");
    })

    $(".option-values > .x-close").on('click', function(e) {
      e.preventDefault();
      $(".purchase-section").find("button.product-option-selector.size-selector.active").trigger("click");
    })

    $(".colors-drawer .x-close, .colors-drawer .blocker").on('click', function(e) {
      var $p = $(".purchase-section");
      $p.removeClass("active");
      $p.find("button.product-option-selector.color-selector.active").removeClass("active");
      S.scroll.unlock();
      setTimeout(function() {
        if (!$p.find("button.product-option-selector.active").length) {
          // check !!
          $p.removeClass("z-up");
        }
      }, 250)

    })

    $(".product-option-colors").on('click', function(e) {
      e.preventDefault();
      $(".purchase-section").find("button.product-option-selector.color-selector:not(.active)").trigger("click");
    })

    $("button.product-option-selector").each(function() {
      var optionSelector = $(this);

      $(this).click(function(e) {
        if(e.target.classList.contains('color-selector')){
          setTimeout(()=>{
            document.querySelector('.colors-drawer-interior .x-close')?.focus();
          }, 500)
        }

        if (!$(this).attr("data-custom-drawer")) {
          // everything else except color, currently this means size
          e.preventDefault();
          var $options = $(this).siblings(".option-values").first();
          var $selector = $(this).parents(".selector-wrapper").first();
          if ($(this).hasClass("active") && window.innerWidth < 767) {
            $options.removeClass("active"); //
            setTimeout(() => {
              $options.css('display', 'none');
            }, 250);
            $(this).attr('aria-expanded', false);
            $selector.focus();
            $selector.removeClass("active");
            $(document).off('click', optionSelectorClick);

            S.scroll.unlock();
          } else {
            $options.addClass("active");
            $options.css('display', 'block');
            $(this).attr('aria-expanded', true);
            $selector.addClass("active");
            $(document).on('click', optionSelectorClick);

            if (!S.isDesktop) {
              S.scroll.lock();
            }
          }
        }

        var $p = $(".purchase-section");
        // both color and size
        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          if ($(this).attr("data-custom-drawer")) {
            var id = $(this).attr("data-custom-drawer");
            // custom drawer is open, so close that too
            if (id) {
              var $t = $("."+id);
              $t.find(".x-close").trigger("click");

              setTimeout(() => {
                $t.css('display', 'none');
              }, 250);
            }
          }
        } else {
          if ($p.find("button.product-option-selector.active").length) {
            // others, so close those first
            $p.find("button.product-option-selector.active").trigger("click");
          }
          S.scroll.lock();
          $(this).addClass("active");
        }



        if (!$p.find("button.product-option-selector.active").length) {
          $p.removeClass("active");
          setTimeout(function() {
            // first let the drawer slide out
            if (!$p.find("button.product-option-selector.active").length) {
              // check again!!
              $p.removeClass("z-up");
            }
          }, 300)

        } else {
          $p.addClass("active z-up");
        }
      })

      function optionSelectorClick(event) {
        var $options = optionSelector.siblings('.option-values').first();
        var $selector = optionSelector.parents('.selector-wrapper').first();

        var targetOptionSelector = $(event.target).closest('button.product-option-selector');
        var targetOptionValues = $(event.target).closest('.option-values');

        // Close drop-down if click target wasn't inside target
        if ( ! targetOptionSelector.length && ! targetOptionValues.length) {
          $('button.product-option-selector').removeClass('active');
          $options.removeClass('active');
          $selector.removeClass('active');

          $(document).off('click', optionSelectorClick);
        }
      }
    })

    $(".product-option-size").each(function() {
      var $variant = S.pdp.getVariantInput($(this));
      if ($variant.attr("data-available") != "true") {
        $(this).addClass("sold-out");
        $(this).attr('disabled', true);
        $(this).find('input').attr('disabled', true);
      }

      $(this).click(function(e) {
        e.preventDefault();
        $(this).addClass("selected").siblings().removeClass("selected");
        if($(this).hasClass("sold-out")) {
          $('.product-add .add-to-cart').attr('disabled', true).text('Sold Out').addClass('disabled');
          $('.product-add').addClass('disabled');
        } else {          
          $('.product-add .add-to-cart').attr('disabled', false).text('Add to cart');
          $('.product-add').removeClass('disabled');
        }          
        var $variant = S.pdp.getVariantInput($(this));
        $variant.siblings().prop('checked', false);
        $variant.prop('checked', true);
        value = $(this).attr("data-value");

        var price = $variant.attr("data-price"), compare_price = $variant.attr("data-orig-price"), available = $variant.attr("data-available");
        $(".product-details .price-wrapper .compare-price").remove();
        $(".product-details .price-wrapper .price").html(price);
        if (compare_price != price && compare_price) {
          $(".product-details .price-wrapper").prepend('<span class="compare-price">'+compare_price+'</span>');
        }
      })
    })


    $(".product-option-size.selected").trigger("click");

    S.scroll.pdpWatcher = scrollMonitor.create($(".pdp-breaker"));
    if (S.scroll.pdpWatcher.isInViewport) {
      $(".purchase-section-interior, .preorder, .scroll-up, .nav-main").addClass("purchase-absolute");
    }
    S.scroll.pdpWatcher.exitViewport(function() {
      if (S.scroll.pdpWatcher.isBelowViewport) {
        $(".purchase-section-interior, .preorder, .scroll-up, .nav-main").removeClass("purchase-absolute");
      }

    });
    S.scroll.pdpWatcher.enterViewport(function() {
      $(".purchase-section-interior, .preorder, .scroll-up, .nav-main").addClass("purchase-absolute");
    });

    const sizeOptionArr = document.querySelectorAll('.product-option-size');
    sizeOptionArr.forEach( el => {
      el.addEventListener('keydown', e => {

        if ( e.key == 'Tab' && e.shiftKey) {
          document.querySelector('.blocker').click();
        } else if ( e.key == 'Tab' && !e.shiftKey) {
          document.querySelector('.blocker').click();
        }

      })
    })

  }




  S.promoBar = function() {
    if ($(".notification-bar").length) {
      var $bar = $(".notification-bar");
      var promocookie = Cookies.get('fog_promo_closed');
      if (promocookie) {
        $bar.remove();
        $(".with-promo-bar").removeClass("with-promo-bar with-white-bar");
      } else {
        var $header = $(".header");
        S.scroll.promoWatcher = scrollMonitor.create($bar);
        if (S.scroll.promoWatcher.isInViewport) {
          $(".without-promo-bar").addClass("with-promo-bar");
          $header.removeClass("header--scrolled header--actually-scrolled");
        }
        S.scroll.promoWatcher.exitViewport(function() {
          $(".with-promo-bar").addClass("without-promo-bar").removeClass("with-promo-bar");
          $header.addClass("header--scrolled header--actually-scrolled");
        });
        S.scroll.promoWatcher.enterViewport(function() {
          $(".without-promo-bar").addClass("with-promo-bar");
          $header.removeClass("header--scrolled header--actually-scrolled");
        });

        $bar.find(".x-sm-close").click(function(e) {
          e.preventDefault();
          $bar.remove();
          S.scroll.promoWatcher.destroy();
          $(".with-promo-bar").removeClass("with-promo-bar with-white-bar ");
          Cookies.set('fog_promo_closed', 'true'); // remember to not show again
        })
      }
    }
  }





  S.init = function() {
    S.isTouchDevice = isTouchDevice();
    // console.log("S.isTouchDevice: " + S.isTouchDevice);

    S.scroll.action();
    $(window).bind("scroll", S.scroll.action);

    S.size.all();
    setTimeout(function() {
      S.size.all();
      $(window).on('resize', function() {
        S.resizeTimer && clearTimeout(S.resizeTimer);
        S.resizeTimer = setTimeout(S.size.all, 300);
      });
    }, 100);

    var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
      }
    }


    S.promoBar();

    $(".scroll-up").on('click', function(e) {
      e.preventDefault();
      $("body,html").animate({
        scrollTop: 0
      }, 150)
    })


    $('body').on('click', '.image-viewer a.close', function(e) {
      closeViewer(e);
    });

    $('body').on('click', 'a.current.close', function(e) {
      e.preventDefault();
      closeViewer(e);
    });

    $('body').on('click', '.video-viewer a.close', function(e) {
      closeVideoViewer(e);
    });


    // Used in the following templates:
    // sections/7th-lookbook.liquid
    // sections/lookbook-nike-idmag.liquid
    // sections/lookbook-nike-spring19.liquid
    // templates/page.lookbook.liquid
    // templates/page.nike-lookbook.liquid
    // templates/page.sense-magazine-editorial.liquid
    // templates/page.sixth-collection-lookbook.liquid
    // templates/page.sixth-collection-stillframes.liquid
    // templates/page.third-collection-campaign.liquid
    var ll = new LazyLoad({
        threshold: 0,
        callback_set: function(el) {
         frames = $('.lookbook-wrapper .look');
        }
    });

    $("[data-custom-drawer]").on('click', function(e) {
      e.preventDefault();
      var id = $(this).attr("data-custom-drawer");
      if (id) {
        var $t = $("."+id);
        if ($t.length) {
          if (!$t.hasClass("active")) {
            S.scroll.lock();
            setTimeout(() => {
              $t.addClass("active");
            }, 100)
            $t.css('display', 'block');
            $t.find('.x-close').focus();
          }
        }
      }
    })

    $(".drawer").each(function() {
      $(this).find(".x-close,.blocker").click(function(e) {
        e.preventDefault();
        var $p = $(this).parents(".drawer").first();
        $p.removeClass("active");
        const classes = $p.attr('class').split(/\s+/);

        classes.forEach(c => {
          if (c.includes('-drawer')) {
            const triggerSelector = `[data-custom-drawer="${c}"]`;
            const trigger = document.querySelector(triggerSelector);

            if (trigger) {
              trigger.focus();
            }
          }
        });

        setTimeout(() => {
          $p.css('display', 'none');
        }, 250);
        S.scroll.unlock();
      })

      const drawerElement = $(this).get(0);
      const firstFocusableElement = drawerElement.querySelector('.x-close');
      const drawerItems = [...drawerElement.querySelectorAll('.color-item')].reverse();
      const lastFocusableElement = drawerItems.find(el => {
        return getComputedStyle(el).display !== 'none';
      });

      drawerElement.addEventListener('keydown', (e) => {
        if (e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
          e.preventDefault();
          lastFocusableElement.focus();
        } else if (e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
          e.preventDefault();
          firstFocusableElement.focus();
        }
      });
    })

    $(".expandable-title").on('click', function(e) {
      e.preventDefault();
      var $t = $(this).parents(".expandable-text");
      if ($t.hasClass("active")) {
        $t.removeClass("active");
        e.target.setAttribute('aria-expanded', 'false');
        setTimeout(() => {
          $t.find('.expandable-content').css('display', 'none');
        }, 200);
      } else {
        $t.siblings(".expandable-text.active").removeClass("active");
        $t.addClass("active");
        e.target.setAttribute('aria-expanded', 'true');
        setTimeout(() => {
          $t.find('.expandable-content').css('display', 'block');
        }, 200);
      }
    })


    $('.share-enable:not(.expandable-title)').on('click', function(e) {
      e.preventDefault();
      $('.share--product').toggleClass('open');
    });

    var shareUrl = window.location.host + window.location.pathname;
    $('.share-list-item--fb').on('click', function(e) {
      var fbTitle;
      var fbProductTitle = $(this).data('title');
      fbTitle = 'The ' + fbProductTitle + ' from @fearofgod Sixth Collection ';
      window.open('http://www.facebook.com/sharer.php?u=' + 'https%3A%2F%2F' + shareUrl + '&t=' + fbTitle, 'facebookMessage', 'width=600, height=300');
      e.preventDefault();
    });

    $('.share-list-item--tw').on('click', function(e) {
      var twText;
      var twProductTitle = $(this).data('title');
      twText = 'The ' + twProductTitle + ' from @fearofgod Sixth Collection ';
      window.open('http://twitter.com/share/?text=' + twText + '&url=https://' + shareUrl, 'twitterMessage', 'width=600, height=300');
      e.preventDefault();
    });


    // nav hovers

    var navItemActive;
    var navTopActive;
    var navTimeout;
    var navWait = 200;

    $(".header-interior").hoverIntent(function() {
      if (S.isDesktop && !S.isTouchDevice) {
        //console.log('hoverIntent header-interior in');
        $(".header").addClass("header--toggled");
      }
    }, function() {
      if (S.isDesktop && !S.isTouchDevice) {
        //console.log('hoverIntent header-interior out');
        $(".header").removeClass("header--toggled header--subopen header--searchopen");
        $(".header .hovered").removeClass("hovered");
      }
    });

    $(".header .nav-item.top-level.has-secondary").hoverIntent(function() {
      if (S.isDesktop && !S.isTouchDevice) {
        //console.log('hoverIntent in');
        var $h = $(".header");
        $h.addClass("header--subopen");
        navItemActive = $(this);
        $(this).addClass("hovered");
        $(this).siblings(".hovered").removeClass("hovered");
        if ($(this).hasClass("nav-search-item")) {
          $h.addClass("header--searchopen");
          //$(".search-bar").trigger('focus');

        } else {
          $h.removeClass("header--searchopen");

        }
/*
*/
        navTopActive = true;
        clearTimeout(navTimeout);
      }
    }, function() {
      if (S.isDesktop && !S.isTouchDevice) {
        //console.log('hoverIntent out');
        //$(this).removeClass("hovered");

        navTopActive = false;
        navTimeout = setTimeout(hideSubNav, navWait);
      }
    });
/*
    document.getElementsByClassName('nav-search')[0].addEventListener('click', function() {
      if (S.isDesktop && !S.isTouchDevice) {
        var $h = $(".header");
        if($h.hasClass("header--searchopen")) {

          //console.log('hoverIntent in');
          $h.addClass("header--subopen");
          navItemActive = $(this);
          $(this).addClass("hovered");
          $(this).siblings(".hovered").removeClass("hovered");
          if ($(this).hasClass("nav-search-item")) {
            $h.addClass("header--searchopen");
            $(".search-bar").trigger('focus');

          } else {
            $h.removeClass("header--searchopen");
          }

          navTopActive = true;
          clearTimeout(navTimeout);

        } else {
          $h.addClass("header--subopen");
          $h.addClass("header--searchopen");
          $(".search-bar").trigger('focus');
          navTopActive = true;

        }

      }
    })
*/
    $(".header .nav-item.top-level:not(.has-secondary)").hoverIntent(function() {
      if (S.isDesktop && !S.isTouchDevice) {
        //console.log('hoverIntent in not secondary');
        var $h = $(".header");
        $h.removeClass("header--subopen");
        $(this).addClass("hovered");
        $(this).siblings(".hovered").removeClass("hovered");

        navTopActive = true;
        clearTimeout(navTimeout);
      }
    }, function() {
      if (S.isDesktop && !S.isTouchDevice) {
        //console.log('hoverIntent out not secondary');
        $(this).removeClass("hovered");

        navTopActive = false;
      }
    })

    document.querySelector('.nav-search').addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleSearchBar()
      }
    })

    document.querySelector('.nav-search').addEventListener('click', e => {
      e.preventDefault();
      toggleSearchBar()
    })

    document.getElementsByClassName('searchbar-close')[0].addEventListener('click', e => {
      e.preventDefault();
      toggleSearchBar();
    })

    document.getElementsByClassName('searchbar-close')[0].addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleSearchBar()
      }
    })


    function toggleSearchBar(){
      let header = document.querySelector('.header');
      if(!header.classList.contains('header--searchopen')) {
        openSearchBar();
      } else {
        closeSearchBar();
      }
    }

    function openSearchBar(){
      let header = document.querySelector('.header');
      header.classList.add('header--toggled');
      header.classList.add('header--subopen');
      header.classList.add('header--searchopen');
      document.querySelector('.nav-search-item').classList.add('hovered');
      document.querySelector('.nav-search-item .secondary-nav').classList.add('init');
      document.querySelector('.search-bar').focus();
    }

    function closeSearchBar(){
      let header = document.querySelector('.header');
      header.classList.remove('header--toggled');
      header.classList.remove('header--subopen');
      header.classList.remove('header--searchopen');
      document.querySelector('.nav-search-item').classList.remove('hovered');
      document.querySelector('.nav-search-item .secondary-nav').classList.remove('init');
      document.querySelector('.nav-search').focus();
    }

    function toggleSecondaryNav(hoveredEl){
      let header = document.querySelector('.header');
      if(!header.classList.contains('header--subopen')) {
        openSecondaryNav(hoveredEl);
      } else {
        closeSecondaryNav(hoveredEl);
      }
    }

    function openSecondaryNav(hoveredEl){
      let header = document.querySelector('.header');
      header.classList.add('header--toggled');
      header.classList.add('header--subopen');
      // header.classList.add('header--searchopen');
      hoveredEl.classList.add('hovered');
      hoveredEl.getElementsByClassName('secondary-nav-btn')[0].setAttribute('aria-expanded', 'true');
    }

    function closeSecondaryNav(hoveredEl){
      let header = document.querySelector('.header');
      header.classList.remove('header--toggled');
      header.classList.remove('header--subopen');
      // header.classList.remove('header--searchopen');
      hoveredEl.classList.remove('hovered');
      hoveredEl.getElementsByClassName('secondary-nav-btn')[0].focus();
      hoveredEl.getElementsByClassName('secondary-nav-btn')[0].setAttribute('aria-expanded', 'false');
    }

    function debounce(fn, delay = 200) {
      let timer;
      return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    }

    [...document.getElementsByClassName('secondary-nav-btn')].forEach(btn => {
      const debouncedToggle = debounce((parentNode) => toggleSecondaryNav(parentNode));

      btn.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          debouncedToggle(e.target.parentNode);
        }

        if (e.key === 'Tab' && e.shiftKey) {
          closeSecondaryNav(e.target.parentNode);
        }
      });

      btn.addEventListener('click', e => {
        debouncedToggle(e.target.parentNode);
      });
    });

    // add keydown listeners to secondary nav links
    [...document.getElementsByClassName('secondary-nav')].forEach( secondaryNav => {
      const focusableElements = [...secondaryNav.getElementsByTagName('a')];
      const lastFocusableElement = focusableElements[focusableElements.length - 2];
      //console.log('focusableElements ', focusableElements);
      //console.log('lastFocusableElement', lastFocusableElement);

      // close secondary nav 
      if(lastFocusableElement){
        lastFocusableElement.addEventListener('keydown', e => {
          console.log('last');
          if (e.key === 'Tab' && !e.shiftKey) {
            //console.log('last');
            //console.log(secondaryNav.parentNode)
            closeSecondaryNav(secondaryNav.parentNode);
          }
        })
      }

      // close secondary nav on Escape key 
      focusableElements.forEach(el => {
        el.addEventListener('keydown', e => {
          if (e.key === 'Escape') {
            closeSecondaryNav(secondaryNav.parentNode);
          }
        })
      })  
    })


    /*
    $(".header-interior").on('mouseenter', function() {
      if (S.isDesktop && !S.isTouchDevice) {
        console.log('mousenter header-interior in');
        $(".header").addClass("header--toggled");
      }
    });

    $(".header-interior").on('mouseleave', function() {
      if (S.isDesktop && !S.isTouchDevice) {
        console.log('mouseleave header-interior out');
        $(".header").removeClass("header--toggled header--subopen header--searchopen");
        $(".header .hovered").removeClass("hovered");
      }
    });

    $(".header .nav-item.top-level.has-secondary").on('mouseenter', function() {
      if (S.isDesktop && !S.isTouchDevice) {
        console.log('mousenter in');
        var $h = $(".header");
        $h.addClass("header--subopen");
        navItemActive = $(this);
        $(this).addClass("hovered");
        $(this).siblings(".hovered").removeClass("hovered");
        if ($(this).hasClass("nav-search-item")) {
          $h.addClass("header--searchopen");
          $(".search-bar").focus();
        } else {
          $h.removeClass("header--searchopen");
        }

        navTopActive = true;
        clearTimeout(navTimeout);
      }
    });

    $(".header .nav-item.top-level.has-secondary").on('mouseleave', function() {
      if (S.isDesktop && !S.isTouchDevice) {
        console.log('mouseleave out');
        //$(this).removeClass("hovered");

        navTopActive = false;
        navTimeout = setTimeout(hideSubNav, navWait);
      }
    });

    $(".header .nav-item.top-level:not(.has-secondary)").on('mouseenter', function() {
      if (S.isDesktop && !S.isTouchDevice) {
        console.log('mousenter in not secondary');
        var $h = $(".header");
        $h.removeClass("header--subopen");
        $(this).addClass("hovered");
        $(this).siblings(".hovered").removeClass("hovered");

        navTopActive = true;
        clearTimeout(navTimeout);
      }
    });

    $(".header .nav-item.top-level:not(.has-secondary)").on('mouseleave', function() {
      if (S.isDesktop && !S.isTouchDevice) {
        console.log('mouseleave out not secondary');
        $(this).removeClass("hovered");

        navTopActive = false;
      }
    });
    */

    $('.secondary-nav').on('mouseenter', function() {
        //console.log('mousenter secondary nav');
        clearTimeout(navTimeout);
    });

    $('.secondary-nav').on('mouseleave', function() {
        //console.log('mouseleave secondary nav');
        navTimeout = setTimeout(hideSubNav, navWait);
    });

    $('.secondary-nav').on('transitionend', function() {
        //console.log($(this), $(this).css('opacity'));
        if ($(this).css('opacity') == 1) {
            $(this).addClass('init');

            return false;
        }

        $(this).removeClass('init');
    });

    function hideSubNav() {
      //console.log('hideSubNav');
      if (S.isDesktop && !S.isTouchDevice && !navTopActive) {
        navItemActive.removeClass("hovered");
        $(".header").removeClass("header--subopen header--searchopen");
      }
    }

    $('.nav-search').on('click', function(e) {
        e.preventDefault();
    });

    // nav clicks for devices

    $(".shopify-section.header-section .secondary-nav .x-sm-close").on('click', function(e) {
      if (!S.isDesktop) {
        e.preventDefault();
        $(".header").removeClass("header--subopen header--searchopen");
        $(".header .nav-item.top-level.has-secondary.hovered").removeClass("hovered");
        $(".nav-main.device-only").find(".hovered").removeClass("hovered");
        S.scroll.unlock();
      }
    })

    $(".header button.blocker").on('click', function(e) {
      e.preventDefault();
      var $h = $(".header");
      if ($h.hasClass("header--searchopen")) {
        $h.removeClass("header--toggled");
      }
      $h.removeClass("header--subopen header--searchopen").find(".hovered").removeClass("hovered");
      $(".nav-main.device-only").find(".hovered").removeClass("hovered");
      if (S.isTouchDevice && S.isLandscape) {
        $h.removeClass("header--toggled");
      }

      S.scroll.unlock();

    })

    $(".shopify-section.header-section .nav-item.top-level.has-secondary .nav-item-link").on('click', function(e) {
      if (!S.isDesktop || S.isTouchDevice) {
        var $h = $(".header");
        var $p = $(this).parents(".nav-item").first();
        e.preventDefault();
        if (!$p.hasClass("hovered")) {
          $h.addClass("header--subopen");
          $p.addClass("hovered");
          $p.siblings(".hovered").removeClass("hovered");
          if (S.isTouchDevice && S.isLandscape) {
            $h.addClass("header--toggled");
          }
          if ($(this).hasClass("nav-search")) {
            $h.addClass("header--searchopen");
            $h.addClass("header--toggled");
          }
          S.scroll.lock();
        }

      }
    })

    /*
    $(".nav-main .nav-link.has-tertiary").click(function(e) {
      if (!S.isDesktop) {
        e.preventDefault();
        $(this).parents(".has-secondary").first().find(".has-tertiary.hovered").removeClass("hovered");
        $(this).addClass("hovered");
      }
    }) */

    const klaviyoSignupForms = document.querySelectorAll('.klaviyo-signup-form');
    klaviyoSignupForms.forEach((form) => {
      if (window.KlaviyoSubscribe) {
        window.KlaviyoSubscribe.attachToForms(form, {
          hide_form_on_success: true,
          success_message: form.dataset.successMsg,
          success: function ($form) {
        // `$form` is a jQuery wrapper around the form that was submitted. This makes it easy to get the email address or form fields.
          $form.addClass("submitted");
        }
        });
      }
    });

    S.list.pop();

    $('.image-carousel.hero-slick').slick({
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      fade: true,
      speed: 1500,
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnFocus: false,
      pauseOnHover: false
    });

    [...document.getElementsByClassName('heroPauseBtn')].forEach( el => {
      el.addEventListener('click', () => {
        togglePlayPause(el);
      });

      el.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          togglePlayPause(el);
        }
      });
    });

    function togglePlayPause(el) {
      console.log('togglePlayPause');
      if (el.classList.contains('paused')) {
        $('.image-carousel.hero-slick').slick('slickPlay');
        el.classList.remove('paused');
      } else {
        $('.image-carousel.hero-slick').slick('slickPause');
        el.classList.add('paused');
      }
    };
    $('.image-carousel.hero-slick').on('init', function(event, slick){
      updateHeaderColor(event, slick);
    });

    $('.image-carousel.hero-slick').on('beforeChange', function(event, slick){
      updateHeaderColor(event, slick);
    });

    function updateHeaderColor(event, slick){
      let header = document.getElementsByTagName('header')[0];
      //console.log(slick)
      //console.log(slick.currentSlide)
      //console.log('slide change');

      let nextSlide = slick.currentSlide + 1;
      if(nextSlide >= slick.slideCount) {
        nextSlide = 0;
      }

      if(headerTextColorArr[nextSlide] == 'black'){
        header.classList.remove('reverse'); 
      } else {
        header.classList.add('reverse'); 
      }
    }

    $('.image-carousel.landing-slick').slick({
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      speed: 1500,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnFocus: false,
      pauseOnHover: false
    });

    $(".collection-nav-wrapper").hoverIntent(function() {
      if (S.isDesktop && !S.isTouchDevice) {
        $(".active-category-nav").addClass("active");
      }
    }, function() {
      if (S.isDesktop && !S.isTouchDevice) {
        $(".active-category-nav").removeClass("active");
      }
    })

    $(".active-category-nav").on('click', function(e) {
      if (!S.isDesktop || S.isTouchDevice) {
        e.preventDefault();
        var $c = $(".collection-header");
        if (!$(this).hasClass("active")) {
          $(this).addClass("active");
          $c.addClass("active category-nav-active");
          $(".nav-main").addClass("z-down");
          S.scroll.lock();
        } else {
          $(this).removeClass("active");
          $c.removeClass("active category-nav-active");
          $(".nav-main").removeClass("z-down");
          S.scroll.unlock();
        }
      }
    });

    $(".filters-toggle").on('click', function(e) {
      e.preventDefault();
      var $c = $(".collection-header"), $f = $(this).siblings(".filters-body").first(), $h = $(".header");
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $c.removeClass("active filters-active");
        $f.removeClass("active");
        $h.removeClass("filters-open");
      } else {
        $(this).addClass("active");
        $f.addClass("active");
        $c.addClass("active filters-active");
        $h.addClass("filters-open");
      }
    })

    /*
    if ($(".filters-body").length) {
      S.scroll.filtersWatcher = scrollMonitor.create($(".filters-body"));
      S.scroll.filtersWatcher.exitViewport(function() {
        if ($(this.watchItem).hasClass("active")) {

        }
        if (S.scroll.filtersWatcher.isBelowViewport) {
          $(".purchase-section-interior, .preorder, .scroll-up, .nav-main").removeClass("purchase-absolute");
        }

      });

    }
    */

    S.zoom.init($(".page-container"));
    S.lookbook.init();
    // S.overview.init();
    S.film.init();
    S.pdp.init();

    setTimeout(function() {
      $("body").addClass("init");
    }, 500)


    initZoom();
    revealModal();


  }

  S.init();

});

function isTouchDevice() {
  try {
    document.createEvent("TouchEvent");
    return true;
  } catch (e) {
    return false;
  }
}

function closeViewer(e) {
  e.preventDefault();
  $.scrollLock( false );
  frameIndex = 0;
  $('body').removeClass('frame-open no-scroll');
  $('.image-viewer').removeClass('visible');
  setTimeout(function() {
    $('.image-viewer').remove();
  }, 500);
}

function openViewer(e) {
  e.preventDefault();
  $.scrollLock( true );
  var frameSrc = frames[frameIndex].dataset.attrFullsize;
  $('body').append('<div class="image-viewer"><a class="close" href="#">CLOSE</a><div class="lookbook-style-images"><div class="frame-container grid justify-center align-center"><div class="frame-wrapper frame"><div class="frameNav prevFrame"></div><div class="frameNav nextFrame"></div><div class="photo grid justify-center align-center"><img class="img-stilframe" src="' + frameSrc + '" /></div></div></div></div></div>');

  $('.image-viewer').imagesLoaded(function() {
    $('body').addClass('frame-open no-scroll');
    $('.image-viewer').addClass('visible');

    var trailerVid = $('#trailer-video')[0];
    if ($('#trailer-video').parents('.video-wrap').find('.audio-control').hasClass('on')) {
      trailerVid.muted = true;
      $('#trailer-video').parents('.video-wrap').find('.audio-control').removeClass('on');
    }

    $('.frameNav.prevFrame').on('click', function(e) {
      minusFrame(frameIndex);
    });

    $('.frameNav.nextFrame').on('click', function(e) {
      plusFrame(frameIndex);
    });

  });
}

function revealModal() {
  $('.reveal[data-reveal]').on('click', function(e) {
    e.preventDefault();
    $.scrollLock( true );
    $('body').toggleClass('frame-open no-scroll');

    var revealBox = $(this).attr('data-reveal');
    $(revealBox).toggleClass('open');

    $(document).on('click', modalClick);
  });

  $('.reveal-modal').on('click', function(e) {
    e.preventDefault();
    $.scrollLock( false );
    $('body').removeClass('frame-open no-scroll');

    $('.reveal-modal').removeClass('open');

    $(document).off('click', modalClick);
  });
}

function modalClick(event) {
  var targetModalLink = $(event.target).closest('.reveal[data-reveal]');
  var targetModal = $(event.target).closest('.reveal-modal');

  console.log('modalClick', ! targetModalLink.length, ! targetModal.length);

  // Close modal if click target wasn't inside target
  if ( ! targetModalLink.length && ! targetModal.length) {
    $('.reveal-modal').removeClass('open');

    $(document).off('click', modalClick);
  }
}

function closeVideoViewer() {
  $('body').removeClass('video-open no-scroll');
//   $('#viewer-video video').get(0).pause();
}

$(document).on('keydown', function(e) {
  if(e.keyCode == 39 || e.keyCode == 40) {
    plusFrame(frameIndex);
  }
  if(e.keyCode == 37 || e.keyCode == 38) {
    minusFrame(frameIndex);
  }
});

function plusFrame(n) {
  if((n+1) < frames.length) {
    frameIndex = n+1;
    showFrame(frameIndex);
  } else {

  }
}

function minusFrame(n) {
  if(n > 0) {
    frameIndex = n - 1;
    showFrame(frameIndex);
  }
}

function currentFrame(n) {
  showFrame(frameIndex = n);
}

function showFrame(n) {
  $('.photo .img-stilframe').attr('src', frames[n].dataset.attrFullsize);
}


$(document).on('keydown', function(e) {
  if(e.keyCode == 27) {
    if($('body.frame-open').length) {
      closeViewer(e);
    }
//     closeVideoViewer(e);
  }
});

var initZoom = function() {
  //if( !isTouchDevice() ) {
  if (isTouchDevice()) {
    $('body').addClass('is-touch-device');
  } else {
    $('body').addClass('not-touch-device');
  }

  $('.look[data-attr-fullsize]').on('click', function(e) {
    frameIndex = $('.lookbook-wrapper .look').index(this);
    openViewer(e);
  });

  $('[data-video]').on('click', function(e) {
    e.preventDefault();

    if (isTouchDevice()) {
      window.location.href = $(this).attr('data-video');
    } else {

      setTimeout(function() {
        $('#viewer-video video').get(0).play();
      }, 300);

      setTimeout(function() {
        $('body').addClass('video-open no-scroll');
        $('#viewer-video video')[0].onended = function() {
          closeVideoViewer();
        };
      }, 400);
    }

  });

  $('body').on('click', '.video-viewer', function(e) {
    // e.preventDefault();
    // closeVideoViewer();
  });

  $('body').on('click', '.attr-link a', function(e) {
    e.stopPropagation();
  });

  $('body').on('touchstart click', '.mobile-attr a', function(e) {
    e.stopPropagation();
    window.location.href = $(this).attr('href');
  });

}



function initSlack() {
  jQuery('.image-carousel.slack').slick({
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true
  });
};

function initMenu() {
	jQuery('.mobile-menu-toggle').on('click', function(e) {
		e.preventDefault();
		jQuery('html').toggleClass('menuActive');
	});
	jQuery('.has-sub-menu a.sub-menu-toggle').on('click', function(e) {
		e.preventDefault();
		jQuery(this).parent('.has-sub-menu').children('.sub-menu-wrapper').toggleClass('open');
	});

  const navOverlay = document.querySelector('.nav-overlay');

  document.addEventListener('keydown', (event) => {
    if (!navOverlay) return;
  
    // ESC to hide overlay
    if (event.key === 'Escape' && !navOverlay.hasAttribute('hidden')) {
      navOverlay.setAttribute('hidden', '');
      return;
    }
  
    // Trap focus inside overlay when it's visible
    if (event.key === 'Tab' && !navOverlay.hasAttribute('hidden')) {
      const focusableSelectors = [
        'a[href]',
        'button:not([disabled])',
      ];
  
      const allFocusable = Array.from(
        navOverlay.querySelectorAll(focusableSelectors.join(','))
      );
  
      // Filter to only *visible* elements
      const focusable = allFocusable.filter(el => {
        const style = window.getComputedStyle(el);
        const rect = el.getBoundingClientRect();
        return (
          style.visibility !== 'hidden' &&
          style.display !== 'none' &&
          !el.hasAttribute('hidden') &&
          rect.width > 0 &&
          rect.height > 0
        );
      });
  
      if (focusable.length === 0) {
        event.preventDefault();
        return;
      }
  
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const current = document.activeElement;
  
      if (event.shiftKey && current === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && current === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });
}

function initBag() {
	jQuery('.add-to-cart').on('click', function(e) {
    setTimeout(() => {
		//jQuery('html').toggleClass('cartActive');
      openCart();
    }, 1000)
	});
	jQuery('.mobile-btnBag').on('click', function(e) {
		e.preventDefault();
    openCart();
    //if (!jQuery('html').hasClass('cartActive')) {
      //document.getElementsByClassName('mobile-btnBag-close')[0].focus();
    //} 
		//jQuery('html').toggleClass('cartActive');
	});
	jQuery('.mobile-btnBag-close').on('click', function(e) {
		e.preventDefault();
    closeCart();
		//jQuery('html').removeClass('cartActive');
    //document.getElementsByClassName('mobile-btnBag')[0].focus();
	});
	jQuery('.shoppingBagDrawer .hover').on('click', function(e) {
    //if (!jQuery('html').hasClass('cartActive')) {
      //document.getElementsByClassName('mobile-btnBag-close')[0].focus();
    //} 
		//jQuery('html').removeClass('cartActive');
    closeCart();
	});
}

function openCart(){
  document.getElementsByClassName('shoppingBagDrawer')[0].style.removeProperty('display');
  setTimeout(() => {
    jQuery('html').addClass('cartActive');
  }, 10);
  document.getElementsByClassName('mobile-btnBag-close')[0].focus();
}

function closeCart(){
  if (!jQuery('html').hasClass('cartActive')) {
    document.getElementsByClassName('mobile-btnBag-close')[0].focus();
  } 
  jQuery('html').removeClass('cartActive');
  setTimeout(() => {
    document.getElementsByClassName('shoppingBagDrawer')[0].style.display = 'none';
    document.getElementsByClassName('nav-cart')[0].focus();
  }, 1000);
}

function stickyItem() {
	$(window).on('load', function() {
		if( $('body.product').length == 1 ) {
			var triggerTop = $('.product-wrapper').offset().top;
			var triggerBottom = triggerTop + $('.product-image-container').height();
			var item = $('.lg-sticky');

			$(window).scroll(function() {
			    var curentScroll = $(window).scrollTop();
				var scrollBottom = $(window).scrollTop() + $(window).height();
			    var isSticky = (triggerBottom <= scrollBottom);
			    if (isSticky == true) {
				    item.addClass('freeze');
				} else {
					item.removeClass('freeze');
			    }
			});
		}
	});
}

function hideNav() {

	if ($(window).width() >= 566) {
		var lastScrollTop = 0;
		$(window).on('scroll', function(event){
			var st = $(this).scrollTop();
			//console.log(st, $('.navigation').length);

			if (st > lastScrollTop && st > 260) {
				$('.navigation').addClass('hideNav');
			} else {
				$('.navigation').removeClass('hideNav');
			}

			lastScrollTop = st;
		});

		//$('.navigation').hover(function() {
			//$(this).removeClass('hideNav');
		//});

		$('.navigation').on('mouseenter', function() {
			$(this).removeClass('hideNav');
		});
		$('.navigation').on('mouseleave', function() {
			$(this).removeClass('hideNav');
		});
	}

}

//document.querySelector('a[data-cart-remove="1"]').addEventListener('click', e => {
  //console.log(e.target.closest('shoppingBagDrawer-item'))
//})

function removeClick(){
  document.getElementsByClassName('mobile-btnBag-close')[0].focus();
}

jQuery(document).ready(function() {
	initSlack();
	initMenu();
	initBag();
	//hideNav();
});
stickyItem();

// Trap focus in cart modal
// const cartFirst = document.getElementsByClassName('mobile-btnBag-close')[0];
// const cartLast = document.getElementsByClassName('cont-shopping-btn')[0];
// const cartLast2 = document.getElementsByClassName('cont-shopping-btn')[1];

// [cartLast, cartLast2].forEach( el => {
  // el.addEventListener('keydown', e => {
    // if(document.getElementsByTagName('html')[0].classList.contains('cartActive') && e.code == 'Tab' && !e.shiftKey) {
      // e.preventDefault();
      // cartFirst.focus();
    // }
  // })
// })

//cartLast.addEventListener('keydown', e => {
  //if(document.getElementsByTagName('html')[0].classList.contains('cartActive') && e.code == 'Tab' && !e.shiftKey) {
    //e.preventDefault();
    //cartFirst.focus();
  //}
//})

// cartFirst.addEventListener('keydown', e => {
  // if(document.getElementsByTagName('html')[0].classList.contains('cartActive') && e.code == 'Tab' && e.shiftKey) {
    // e.preventDefault();

    // if(document.getElementsByClassName('shoppingBagControls')[0].style.display == 'none') {
      // console.log('cartLast2.focus()');
      // cartLast2.focus();
    // } else {
      // console.log('cartLast.focus()');
      // cartLast.focus();
    // }

  // }
// })

// Trap focus in searchbar modal
const searchFirst = document.getElementsByClassName('search-bar')[0];
const searchLast = document.getElementsByClassName('searchbar-close')[0];



searchLast.addEventListener('keydown', e => {
  if(e.code == 'Tab' && !e.shiftKey) {
    e.preventDefault();
    searchFirst.focus();
  }
})

//cartLast.addEventListener('keydown', e => {
  //if(document.getElementsByTagName('html')[0].classList.contains('cartActive') && e.code == 'Tab' && !e.shiftKey) {
    //e.preventDefault();
    //cartFirst.focus();
  //}
//})

searchFirst.addEventListener('keydown', e => {
  if(e.code == 'Tab' && e.shiftKey) {
    e.preventDefault();
    searchLast.focus();

  }
});

(()=>{
  const urlParams = new URLSearchParams(window.location.search);
  const cart= urlParams.get('cart');
  if (cart) {
    openCart();
  }
})();

(()=>{
  if(window.gtag){
    [...document.getElementsByClassName('add-to-cart')].forEach((el) => {
      el.addEventListener('click', () => {
        console.log('atc');
        window.gtag('event', 'ab_test_var_a_atc', {
          'location': window.location.href,
        });
      });
    });

    [...document.getElementsByClassName('nav-main')].forEach((nav) => {
      [...nav.getElementsByTagName('a')].forEach((a) => {
        a.addEventListener('click', () => {
          console.log('nav click');
          window.gtag('event', 'ab_test_var_a_nav_click', {
            'location': window.location.href,
          });
        });
      });
    });

    [...document.getElementsByClassName('checkout')].forEach((el) => {
      console.log('checkout btn')
      el.addEventListener('click', () => {
        console.log('ab_test_var_a_begin_checkout');
        window.gtag('event', 'ab_test_var_a_begin_checkout', {
          'location': window.location.href,
        });
      });
    });
  }
})();



document.getElementsByClassName('nav-burger')[0].addEventListener('click', ()=>{
  if (document.getElementsByClassName('header')[0].classList.contains('header--scrolled')){
    console.log('header scrolled');
    document.body.classList.add('scrolled')
  } else {
    document.body.classList.remove('scrolled')
  }
});


(()=>{
  let lastScrollTop = 0;
  window.addEventListener("scroll", function(){ // or window.addEventListener("scroll"....
   let st = window.pageYOffset;
   if (st > lastScrollTop) {
      // downscroll code
    document.body.classList.add('scrolled-down');
    document.body.classList.remove('scrolled-up');
   } else if (st < lastScrollTop) {

    document.body.classList.remove('scrolled-down');
    document.body.classList.add('scrolled-up');
      // upscroll code
   } 
   lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  }, false);
})();


(()=>{
  // mobile menu - on back arrow click return the focus to the submenu link that was clicked
  let mobileMenuCurrOpenSubmenu = null;

  document.querySelectorAll('.nav-overlay__item--has-sublinks a').forEach( el => {
    el.addEventListener('click', e => {
      mobileMenuCurrOpenSubmenu = el;
    })
  });

  document.querySelectorAll('.nav-overlay__back').forEach( el => {
    el.addEventListener('click', e => {
      setTimeout(()=>{
        mobileMenuCurrOpenSubmenu.focus();
      }, 250)
    })
  })
})();




  [...document.getElementsByClassName('megamenuVideoPauseBtn')].forEach( el => {
    el.addEventListener('click', () => {
      togglePlayPause(el);
    });

    el.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        togglePlayPause(el);
      }
    });
  });

  function togglePlayPause(el) {
    console.log(el.parentNode)
    console.log(el.parentNode.getElementsByTagName('video')[0])
    let video = el.parentNode.getElementsByTagName('video')[0];
    console.log('togglePlayPause');
    if (el.classList.contains('paused')) {
      video.play();
      el.classList.remove('paused');
    } else {
      video.pause();
      el.classList.add('paused');
    }
  };